import isNil from 'lodash/isNil';

export class ReportDataModel {
  rt?: Nullable<number>;
  crnAn?: Nullable<number>;
  culet?: Nullable<number>;
  pav1An?: Nullable<number>;
  pavAn?: Nullable<number>;
  table?: Nullable<number>;
  width?: Nullable<number>;
  height?: Nullable<number>;
  length?: Nullable<number>;
  culetPc?: Nullable<number>;
  tablePc?: Nullable<number>;
  heightPc?: Nullable<number>;
  pavDepth?: Nullable<number>;
  crnHeight?: Nullable<number>;
  pavDepthPc?: Nullable<number>;
  crnHeightPc?: Nullable<number>;
  girdleBezel?: Nullable<number>;
  girdleBezelPc?: Nullable<number>;
  dzPavColor?: Nullable<number>;
  dzTableColor?: Nullable<number>;
  fHist?: Nullable<number>;
  fChroma?: Nullable<number>;
}

export default class ReportData extends ReportDataModel {
  constructor({
    rt,
    crnAn,
    culet,
    pav1An,
    pavAn,
    table,
    width,
    height,
    length,
    culetPc,
    tablePc,
    heightPc,
    pavDepth,
    crnHeight,
    pavDepthPc,
    crnHeightPc,
    girdleBezel,
    girdleBezelPc,
    dzPavColor,
    dzTableColor,
    fHist,
    fChroma,
  }: ReportDataModel) {
    super();

    this.rt = !isNil(rt) ? rt : null;
    this.crnAn = !isNil(crnAn) ? crnAn : null;
    this.culet = !isNil(culet) ? culet : null;
    this.pav1An = !isNil(pav1An) ? pav1An : null;
    this.pavAn = !isNil(pavAn) ? pavAn : null;
    this.table = !isNil(table) ? table : null;
    this.width = !isNil(width) ? width : null;
    this.height = !isNil(height) ? height : null;
    this.length = !isNil(length) ? length : null;
    this.culetPc = !isNil(culetPc) ? culetPc : null;
    this.tablePc = !isNil(tablePc) ? tablePc : null;
    this.heightPc = !isNil(heightPc) ? heightPc : null;
    this.pavDepth = !isNil(pavDepth) ? pavDepth : null;
    this.crnHeight = !isNil(crnHeight) ? crnHeight : null;
    this.pavDepthPc = !isNil(pavDepthPc) ? pavDepthPc : null;
    this.crnHeightPc = !isNil(crnHeightPc) ? crnHeightPc : null;
    this.girdleBezel = !isNil(girdleBezel) ? girdleBezel : null;
    this.girdleBezelPc = !isNil(girdleBezelPc) ? girdleBezelPc : null;
    this.dzPavColor = !isNil(dzPavColor) ? dzPavColor : null;
    this.dzTableColor = !isNil(dzTableColor) ? dzTableColor : null;
    this.fHist = !isNil(fHist) ? fHist : null;
    this.fChroma = !isNil(fChroma) ? fChroma : null;
  }
}
